document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".image-with-text__media").forEach((wrapper) => {
    const btn = wrapper.querySelector(".volume_controls");
    if (!btn) return;

    const video = wrapper.querySelector("video");

    btn.addEventListener("click", () => {
      const isMuted = video.muted;
      video.muted = !isMuted;
      btn.dataset.muted = String(!isMuted);
      btn.setAttribute("aria-label", isMuted ? "Mute video" : "Unmute video");
    });
  });
});